import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Servizi from "@/pages/Servizi";
import Arredamento from "@/pages/Arredamento";
import Nautica from "@/pages/Nautica";
import Beauty from "@/pages/Beauty";
import FoodPackaging from "@/pages/FoodPackaging";
import Contatti from "@/pages/Contatti";
import Privacy from "@/pages/Privacy";
import Cookie from "@/pages/Cookie";
import NotFound from "@/pages/NotFound";
import { Toaster } from "sonner";

function useReveal() {
  useEffect(() => {
    const els = () => Array.from(document.querySelectorAll(".reveal:not(.is-visible)"));
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: "0px 0px -10% 0px", threshold: 0.05 }
    );
    els().forEach((el) => io.observe(el));
    const mo = new MutationObserver(() => els().forEach((el) => io.observe(el)));
    mo.observe(document.body, { childList: true, subtree: true });
    return () => { io.disconnect(); mo.disconnect(); };
  }, []);
}

function AppShell() {
  useReveal();
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/servizi" element={<Servizi />} />
          <Route path="/prodotti/componenti-arredamento" element={<Arredamento />} />
          <Route path="/prodotti/componenti-nautica" element={<Nautica />} />
          <Route path="/prodotti/packaging-cosmetico" element={<Beauty />} />
          <Route path="/prodotti/food-packaging-pet" element={<FoodPackaging />} />
          <Route path="/cosmetica" element={<Navigate to="/prodotti/packaging-cosmetico" replace />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookie" element={<Cookie />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default function App() {
  return <div className="App"><AppShell /></div>;
}
